<template>
  <div class="card mg-t-20">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">{{title}}</h6>
      <nav class="nav nav-row-xs align-items-center">
                  <a
                    @click="
                      restrictedDaysData.params.mode = 2;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 2 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1W</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 3;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 3 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1M</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 4;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 4 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1Y</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 5;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 5 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >ALL</a
                  >
                </nav>
    </div>
    <div class="card-body" v-if="restrictedDaysData.rdy">
      <div class="d-flex align-items-center">
                  <div
                    v-for="(d, i) in restrictedDaysData.data.list"
                    :key="i"
                    class="profile-skillset flex-fill"
                  >
                    <h4>
                      <a class="link-01">{{ d.count }}</a>
                    </h4>
                    <label>{{ d.typeName }}</label>
                    <!-- <label v-show="d.day == 1">Даваа</label>
                    <label v-show="d.day == 2">Мягмар</label>
                    <label v-show="d.day == 3">Лхагва</label>
                    <label v-show="d.day == 4">Пүрэв</label>
                    <label v-show="d.day == 5">Баасан</label> -->
                  </div>
                </div>
                <div>
                  <apexchart
                    type="bar"
                    height="250"
                    :options="chartDaysOptions"
                    :series="seriesDays"
                    :key="chartDaysOptionsKey"
                  ></apexchart>
                </div>
    </div>
    <div v-else class="pd-20">
      Боловсруулалт хийж байна...
    </div>
    <div class="card-footer tx-11 tx-color-03" v-if="restrictedDaysData.rdy">
                <div>
                  Хамрах хугацаа:
                  {{
                    restrictedDaysData.data.processed.startDate
                      | moment("YYYY.MM.DD")
                  }}
                  -
                  {{
                    restrictedDaysData.data.processed.endDate
                      | moment("YYYY.MM.DD")
                  }}<br />
                  Боловсруулсан:
                  {{ restrictedDaysData.data.processed.time.toFixed(2) }}сек
                </div>
              </div>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props:{
    title: {
      type: String,
      default: () => ''
    },
    url: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      chartDaysOptions: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      seriesDays: [
        {
          name: "Тоо",
          data: [],
        },
      ],
      restrictedDaysData: {
        rdy: false,
        params: {
          mode: 5,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          list: [],
        },
      },
      colors: ["green", "primary", "orange"],

      vehicleCountData: {
        rdy: 0,
        params: {
          mode: 1,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          allCount: 0,
          distinctedCount: 0,
          processed: {
            time: 0,
            startDate: "2023-01-01",
            endDate: "2023-01-01",
          },
        },
      },
      chartKey: 0,
    };
  },
  mounted() {
    this.loadVehicleCount();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loadVehicleCount() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: this.url },
        params: {
          mode: this.restrictedDaysData.params.mode,
          startDate: this.restrictedDaysData.params.startDate,
          endDate: this.restrictedDaysData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
          this.restrictedDaysData.data = res.data;
          this.seriesDays[0].data = res.data.list.map((x) => {
            return x.count;
          });
          this.chartDaysOptions.xaxis.categories = res.data.list.map((x) => {
            return x.typeName;
          });
          this.chartDaysOptionsKey++;
          this.restrictedDaysData.rdy = true;
        }
      });
    },
  },
};
</script>
